<template>
  <div>
    <div v-for="comment in comments" :key="comment.id">
      <v-card class="mx-auto my-4" style="overflow: visible" elevation="2">
        <v-card-text>
          <div class="d-flex align-center mb-4 justify-space-between">
            <div class="d-flex align-center ga-2">
              <v-avatar color="purple" size="40">
                <v-img
                  v-if="comment.user.image"
                  :src="comment.user.image"
                  alt="User avatar"
                />
                <span v-else class="text-h6 white--text">{{
                  comment.user.first_name.charAt(0)
                }}</span>
              </v-avatar>
              <div class="font-weight-medium">
            
                {{ comment.user.full_name }}
              </div>
            </div>
            <div class="text-caption grey--text">
              {{ formatDate(comment.created_at) }}
            </div>
          </div>

          <!-- attachments -->
          <div
            v-if="comment.attachments && comment.attachments.length"
            class="d-flex flex-wrap ga-2 mb-3"
          >
            <div
              v-for="(img, index) in comment.attachments"
              :key="index"
              class="w-100 attachment-from-comment"
            >
              <img
                :src="img.file_path"
                alt="attachment"
                style="border-radius: 8px; max-height: 8rem; object-fit: cover"
              />
            </div>
          </div>

          <div
            class="text-body mb-4"
            v-html="sanitizedContent(comment.content)"
          ></div>
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center ga-2">
              <svg
                @click="toggleLike(comment.id)"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 9.27601C16 8.74341 15.7572 8.23301 15.3821 7.90014C15.6469 7.54508 15.7572 7.10125 15.7131 6.65742C15.6248 5.72538 14.7862 4.97087 13.8152 4.97087H10.9462L11.1228 3.59501C11.1669 3.17337 11.1669 2.81831 11.0786 2.46325C10.7476 1.0208 9.46759 0 7.98897 0C7.65793 0 7.3269 0.133148 7.08414 0.377254C6.84138 0.621359 6.70897 0.932039 6.70897 1.26491V3.0846C6.70897 3.8835 6.48828 4.638 6.06897 5.32594L5.29655 6.56865C5.18621 6.74619 5.03172 6.87933 4.85517 6.9681C4.70069 6.47989 4.25931 6.12483 3.72966 6.12483H1.19172C0.529655 6.12483 0 6.65742 0 7.32316V14.8017C0 15.4674 0.529655 16 1.19172 16H3.77379C4.43586 16 4.96552 15.4674 4.96552 14.8017V14.6241C5.53931 15.1345 6.28966 15.4452 7.10621 15.4452H12.7117C13.2193 15.4452 13.7269 15.2233 14.08 14.8682C14.4331 14.5132 14.6097 14.0472 14.5876 13.5589C14.5876 13.3814 14.5655 13.2261 14.4993 13.0485C15.0952 12.7379 15.4924 12.1165 15.4924 11.4064C15.4924 11.1623 15.4483 10.9182 15.36 10.6963C15.7572 10.319 16 9.8086 16 9.27601ZM3.84 14.7795C3.84 14.8239 3.79586 14.8682 3.75172 14.8682H1.19172C1.14759 14.8682 1.10345 14.8239 1.10345 14.7795V7.30097C1.10345 7.25659 1.14759 7.21221 1.19172 7.21221H3.77379C3.81793 7.21221 3.86207 7.25659 3.86207 7.30097V14.7795H3.84ZM14.4772 9.94175C14.3007 10.0305 14.1683 10.1859 14.1241 10.3856C14.08 10.5853 14.1241 10.785 14.2566 10.9404C14.3669 11.0735 14.411 11.2289 14.411 11.3842C14.411 11.7393 14.1462 12.0499 13.7931 12.1165C13.5724 12.1609 13.3738 12.294 13.2855 12.516C13.1972 12.7379 13.2193 12.9598 13.3517 13.1595C13.44 13.2705 13.4841 13.4258 13.4841 13.5811C13.4841 13.7587 13.4179 13.9584 13.2855 14.0915C13.131 14.2469 12.9103 14.3356 12.6897 14.3356H7.08414C5.91448 14.3356 4.94345 13.3814 4.94345 12.1831V8.09986C5.49517 7.96671 5.95862 7.63384 6.26759 7.14563L7.04 5.90291C7.56965 5.05964 7.85655 4.08322 7.85655 3.0846V1.26491C7.85655 1.22053 7.87862 1.17614 7.90069 1.15395C7.92276 1.13176 7.9669 1.10957 8.01103 1.10957C8.98207 1.10957 9.79862 1.77531 10.0193 2.70735C10.0634 2.90707 10.0855 3.15118 10.0414 3.43967L9.84276 4.99307C9.79862 5.25936 9.8869 5.52566 10.0634 5.74757C10.24 5.9473 10.5048 6.08044 10.7697 6.08044H13.8152C14.1903 6.08044 14.5655 6.39112 14.6097 6.74619C14.6317 7.01248 14.4993 7.27878 14.2786 7.43412C14.08 7.56727 13.9697 7.81137 13.9917 8.05548C14.0138 8.29958 14.1683 8.49931 14.411 8.58807C14.6979 8.69903 14.8745 8.96533 14.8745 9.27601C14.8966 9.56449 14.7421 9.8086 14.4772 9.94175Z"
                  fill="#999999"
                />
              </svg>

              <div class="emoji-trigger-container">
                <svg
                  @click="toggleEmojiPicker($event, comment.id)"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.8284 11.8284C11.457 12.1999 11.0161 12.4945 10.5307 12.6955C10.0454 12.8966 9.52529 13 9 13C8.47471 13 7.95456 12.8966 7.46926 12.6955C6.98395 12.4945 6.54299 12.1999 6.17156 11.8284M17 9C17 10.0506 16.7931 11.0909 16.391 12.0615C15.989 13.0321 15.3997 13.914 14.6569 14.6569C13.914 15.3997 13.0321 15.989 12.0615 16.391C11.0909 16.7931 10.0506 17 9 17C7.94943 17 6.90914 16.7931 5.93853 16.391C4.96793 15.989 4.08601 15.3997 3.34315 14.6569C2.60028 13.914 2.011 13.0321 1.60896 12.0615C1.20693 11.0909 1 10.0506 1 9C1 6.87827 1.84285 4.84344 3.34315 3.34315C4.84344 1.84285 6.87827 1 9 1C11.1217 1 13.1566 1.84285 14.6569 3.34315C16.1571 4.84344 17 6.87827 17 9ZM7 7C7 7.368 6.85067 7.66667 6.66667 7.66667C6.48267 7.66667 6.33333 7.368 6.33333 7C6.33333 6.632 6.48267 6.33333 6.66667 6.33333C6.85067 6.33333 7 6.632 7 7ZM6.66667 7H6.67378V7.01333H6.66667V7ZM11.6667 7C11.6667 7.368 11.5173 7.66667 11.3333 7.66667C11.1493 7.66667 11 7.368 11 7C11 6.632 11.1493 6.33333 11.3333 6.33333C11.5173 6.33333 11.6667 6.632 11.6667 7ZM11.3333 7H11.3404V7.01333H11.3333V7Z"
                    stroke="#999999"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <emoji-picker
                  v-if="showEmojiPicker === comment.id"
                  class="emoji-picker"
                  @emoji-click="onEmojiClick"
                  :style="{
                    position: 'fixed',
                    top: emojiPickerPosition.top + 'px',
                    left: emojiPickerPosition.left + 'px',
                  }"
                ></emoji-picker>
              </div>
            </div>
            <v-btn
              variant="text"
              class="reply-btn"
              @click="
                showReplyInput =
                  showReplyInput === comment.id ? null : comment.id
              "
            >
              Reply
            </v-btn>
          </div>
          <div v-if="showReplyInput === comment.id" class="mt-4">
            <div class="d-flex align-center">
              <v-avatar color="purple" size="32" class="mr-3">
                <span class="text-subtitle-2 white--text">M</span>
              </v-avatar>
              <div class="reply-container">
                <v-text-field
                  ref="replyInput"
                  v-model="replyText[comment.id]"
                  label="Write a reply"
                  variant="outlined"
                  density="compact"
                  hide-details
                  @keyup.enter="addReply(comment.id)"
                  class="reply-input"
                ></v-text-field>
              </div>
            </div>
          </div>

          <div
            v-for="reply in comment.replies"
            :key="reply.id"
            class="mt-4 px-4"
          >
            <div class="d-flex ss">
              <v-avatar color="purple" size="32" class="mt-1">
                <v-img
                  v-if="reply?.user?.image"
                  :src="reply?.user?.image"
                  alt="User avatar"
                />
                <span v-else class="text-subtitle-2 white--text">{{
                  reply?.user?.first_name.charAt(0)
                }}</span>
              </v-avatar>
              <div class="ml-3">
                <div class="font-weight-medium">
                  {{ reply?.user?.salutation }}/{{ reply?.user?.first_name }}
                  {{ reply?.user?.last_name }}
                </div>
                <div
                  class="text-body-2"
                  v-html="sanitizedContent(reply.content)"
                ></div>
                <div class="text-caption grey--text">
                  {{ formatDate(reply.created_at) }}
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import "emoji-picker-element";
import apiClient from "@/core/buildRequest";
import DOMPurify from "dompurify";

export default {
  name: "UpdatesCompView",
  props: ["item", "call"],
  data() {
    return {
      showReplyInput: null,
      showEmojiPicker: null,
      replyText: {},
      emojiPickerPosition: {
        top: 0,
        left: 0,
      },
      comments: [],
    };
  },
  methods: {
    toggleLike(commentId) {
      const comment = this.comments.find((c) => c.id === commentId);
      if (comment) {
        comment.liked = !comment.liked;
      }
    },
    async addReply(commentId) {
      console.log(commentId);
      const content = this.replyText[commentId]?.trim();
      if (content) {
        await apiClient.post(`/leads-managment/leads/reply/${commentId}`, {
          content,
        });
        this.getUpdates();
        this.replyText[commentId] = ""; // reset only this one
      }
    },
    toggleEmojiPicker(event, commentId) {
      const trigger = event.currentTarget;
      const rect = trigger.getBoundingClientRect();
      this.emojiPickerPosition = {
        top: rect.top + window.scrollY,
        left: rect.left + rect.width + 5,
      };
      this.showEmojiPicker =
        this.showEmojiPicker === commentId ? null : commentId;
      event.stopPropagation();
    },
    onEmojiClick(event) {
      const emoji = event.detail.unicode;
      this.replyText += emoji;
    },
    handleClickOutside(event) {
      const picker = this.$el.querySelector(".emoji-picker");
      if (picker && !picker.contains(event.target)) {
        this.showEmojiPicker = null;
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async getUpdates() {
      await apiClient
        .get(`/leads-managment/leads/get-updates/${this.$route.params.id}`, {
          params: {
            time: new Date().toISOString(),
          },
        })
        .then((res) => {
          this.comments = res.data.data;
        });
    },
    sanitizedContent(content) {
      return DOMPurify.sanitize(content);
    },
  },
  watch: {
    call() {
      this.getUpdates();
    },
  },
  mounted() {
    this.getUpdates();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}
.reply-btn {
  color: #237276;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
}
.reply-container {
  position: relative;
  flex: 1;
}
.reply-input {
  height: 40px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #d6d6d6;
  box-shadow: 0px 2px 8px 0px #00000014;
}
.cursor-pointer {
  cursor: pointer;
}
.emoji-trigger-container {
  position: relative;
  display: inline-block;
}
.emoji-picker {
  z-index: 1000;
}
.text-body {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
</style>
